var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"application-dropdown"}},[_c('b-navbar-dropdown',{attrs:{"position":"is-bottom-left","label":_vm.displayName}},[_c('b-navbar-item',{attrs:{"value":"logout"},on:{"click":_vm.logOutAndCleanUp}},[_vm._v("Logout")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }